import { render } from "./brand_detail.vue?vue&type=template&id=5e5d6484"
import script from "./brand_detail.vue?vue&type=script&lang=js"
export * from "./brand_detail.vue?vue&type=script&lang=js"

import "./brand_detail.vue?vue&type=style&index=0&id=5e5d6484&lang=css"

import exportComponent from "F:\\code\\ywym\\ydd-zht-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__